export enum SourceTypeEnums {
  MODAL_GALLERY = 'modal-gallery',
  PRODUCT_DETAIL_GALLERY = 'product-detail-gallery',
  MAIN = 'main',
  THUMBNAIL = 'thumbnail',
}
